import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "@/lib/storage";

interface GuestRouteProps {
  children: React.ReactNode;
}

const GuestRoute: React.FC<GuestRouteProps> = ({ children }) => {
  const token = getToken();

  if (  token) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default GuestRoute;
